import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import ProtectedRoute from "./ProtectedRoute";
import MenuPage from "../Pages/MenuPage/MenuPage";
import OrderPage from "../Pages/OrderPage/OrderPage";
import OrderListPage from "../Pages/OrderListPage/OrderListPage";
import LogoutPage from "../Pages/LogoutPage/LogoutPage";
import PutAwayPage from "../Pages/PutAwayPage/PutAwayPage";
import StockCountPage from "../Pages/StockCountPage/StockCountPage";
import QaListPage from "../Pages/QaListPage/QaListPage";
import WrapListPage from "../Pages/WrapListPage/WrapListPage";
import DispatchListPage from "../Pages/DispatchListPage/DispatchListPage";
import AuthLayout from "../Layouts/AuthLayout";
import AnonLayout from "../Layouts/AnonLayout";
import LoginPage from "../Pages/LoginPage/LoginPage";
import PackListPage from "../Pages/PackListPage/PackListPage";
import OrderPackPage from "../Pages/OrderPackPage/OrderPackPage";
import BoxPage from "../Pages/BoxPage/BoxPage";
import PrePickListPage from "../Pages/PrePickListPage/PrePickListPage";
import PrePickPage from "../Pages/PrePickPage/PrePickPage";
import TallyInListPage from "../Pages/TallyInListPage/TallyInListPage";
import TallyInPage from "../Pages/TallyInPage/TallyInPage";
import TallyInLinePage from "../Pages/TallyInLinePage/TallyInLinePage";
import StockRequestListPage from "../Pages/StockRequestListPage/StockRequestListPage";
import StockRequestPage from "../Pages/StockRequestPage/StockRequestPage";
import SalesOrderCustomerPage from "../Pages/SalesOrderCustomerPage/SalesOrderCustomerPage";
import SalesOrderPage from "../Pages/SalesOrderPage/SalesOrderPage";
import StockCheckPage from "../Pages/StockCheckPage/StockCheckPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <AuthLayout />,
        children: [
          {
            path: "",
            element: (
              <ProtectedRoute>
                <MenuPage />
              </ProtectedRoute>
            ),
            handle: "Menu",
          },
          {
            path: "menu",
            element: (
              <ProtectedRoute>
                <MenuPage />
              </ProtectedRoute>
            ),
            handle: "Menu",
          },
          {
            path: "order",
            element: (
              <ProtectedRoute>
                <OrderPage />
              </ProtectedRoute>
            ),
            handle: "Pick Order",
          },
          {
            path: "orderpack",
            element: (
              <ProtectedRoute>
                <OrderPackPage />
              </ProtectedRoute>
            ),
            handle: "Pack Order",
          },
          {
            path: "orders",
            element: (
              <ProtectedRoute checkLoginProp="allow_pick">
                <OrderListPage />
              </ProtectedRoute>
            ),
            handle: "Pick Orders",
          },
          {
            path: "packlist",
            element: (
              <ProtectedRoute checkLoginProp="allow_pack">
                <PackListPage />
              </ProtectedRoute>
            ),
            handle: "Pack",
          },
          {
            path: "box",
            element: (
              <ProtectedRoute checkLoginProp="allow_pack">
                <BoxPage />
              </ProtectedRoute>
            ),
            handle: "Box",
          },
          {
            path: "putaway",
            element: (
              <ProtectedRoute checkLoginProp="allow_putaway">
                <PutAwayPage />
              </ProtectedRoute>
            ),
            handle: "Put Away",
          },
          {
            path: "stockcount",
            element: (
              <ProtectedRoute checkLoginProp="allow_putaway">
                <StockCountPage />
              </ProtectedRoute>
            ),
            handle: "Stock Count",
          },
          {
            path: "stockcheck",
            element: (
              <ProtectedRoute checkLoginProp="allow_stockcheck">
                <StockCheckPage />
              </ProtectedRoute>
            ),
            handle: "Stock Check",
          },
          {
            path: "move",
            element: (
              <ProtectedRoute checkLoginProp="allow_move">
                <PutAwayPage />
              </ProtectedRoute>
            ),
            handle: "BIN Move",
          },
          {
            path: "qa",
            element: (
              <ProtectedRoute checkLoginProp="allow_qa">
                <QaListPage />
              </ProtectedRoute>
            ),
            handle: "QA",
          },
          {
            path: "wrap",
            element: (
              <ProtectedRoute checkLoginProp="allow_wrap">
                <WrapListPage />
              </ProtectedRoute>
            ),
            handle: "Wrap",
          },
          {
            path: "returnstock",
            element: (
              <ProtectedRoute checkLoginProp="allow_return">
                <PutAwayPage />
              </ProtectedRoute>
            ),
            handle: "Return To Stock",
          },
          {
            path: "dispatch",
            element: (
              <ProtectedRoute checkLoginProp="allow_dispatch">
                <DispatchListPage />
              </ProtectedRoute>
            ),
            handle: "Dispatch",
          },
          {
            path: "prepick",
            element: (
              <ProtectedRoute checkLoginProp="allow_prepick">
                <PrePickListPage />
              </ProtectedRoute>
            ),
            handle: "Pre-Pick Orders",
          },
          {
            path: "prepickorder",
            element: (
              <ProtectedRoute>
                <PrePickPage />
              </ProtectedRoute>
            ),
            handle: "Pre-Pick Order",
          },
          {
            path: "salesordercustomer",
            element: (
              <ProtectedRoute checkLoginProp="allow_order">
                <SalesOrderCustomerPage mode="order" key="salesordercustomer" />
              </ProtectedRoute>
            ),
            handle: "New Order",
          },
          {
            path: "salesorder",
            element: (
              <ProtectedRoute checkLoginProp="allow_order">
                <SalesOrderPage mode="order" key="salesorder" />
              </ProtectedRoute>
            ),
            handle: "New Order",
          },
          {
            path: "quotecustomer",
            element: (
              <ProtectedRoute checkLoginProp="allow_quote">
                <SalesOrderCustomerPage mode="quote" key="quotecustomer" />
              </ProtectedRoute>
            ),
            handle: "New Quote",
          },
          {
            path: "quote",
            element: (
              <ProtectedRoute checkLoginProp="allow_quote">
                <SalesOrderPage mode="quote" key="quote" />
              </ProtectedRoute>
            ),
            handle: "New Quote",
          },
          {
            path: "stockrequests",
            element: (
              <ProtectedRoute checkLoginProp="allow_stockrequest">
                <StockRequestListPage />
              </ProtectedRoute>
            ),
            handle: "Stock Requests",
          },
          {
            path: "stockrequest",
            element: (
              <ProtectedRoute checkLoginProp="allow_stockrequest">
                <StockRequestPage />
              </ProtectedRoute>
            ),
            handle: "Stock Request",
          },
          {
            path: "tallyin",
            element: (
              <ProtectedRoute checkLoginProp="allow_3pltallyin">
                <TallyInListPage />
              </ProtectedRoute>
            ),
            handle: "3PL Tally In",
          },
          {
            path: "tallyinorder",
            element: (
              <ProtectedRoute>
                <TallyInPage />
              </ProtectedRoute>
            ),
            handle: "3PL Tally In",
          },
          {
            path: "tallyinline",
            element: (
              <ProtectedRoute>
                <TallyInLinePage />
              </ProtectedRoute>
            ),
            handle: "3PL Tally",
          },
          {
            path: "tallyout",
            element: (
              <ProtectedRoute checkLoginProp="allow_3pltallyout">
                <TallyInListPage />
              </ProtectedRoute>
            ),
            handle: "3PL Tally Out",
          },
          {
            path: "tallyoutorder",
            element: (
              <ProtectedRoute>
                <TallyInPage />
              </ProtectedRoute>
            ),
            handle: "3PL Tally Out",
          },
          {
            path: "tallyoutline",
            element: (
              <ProtectedRoute>
                <TallyInLinePage />
              </ProtectedRoute>
            ),
            handle: "3PL Tally",
          },
        ],
      },
      {
        path: "login",
        element: <AnonLayout />,
        children: [
          {
            path: "",
            element: <LoginPage />,
            handle: "Login",
          },
          {
            path: ":step",
            element: <LoginPage />,
            handle: "LoginStep1",
          },
          {
            path: ":step/:dbkey",
            element: <LoginPage />,
            handle: "LoginStep3",
          },
        ],
      },
      {
        path: "logout",
        element: <AnonLayout />,
        children: [
          {
            path: "",
            element: <LogoutPage />,
            handle: "Logout",
          },
        ],
      },
    ],
  },
]);
